import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const AwardOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M18.53 9.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm.259 5.5a8.5 8.5 0 0 1-5.26 2.933l1.865 3.296a.3.3 0 0 0 .527-.008l1.427-2.733 3.013.162a.3.3 0 0 0 .276-.45zm-13.401.018a8.5 8.5 0 0 0 5.26 2.932l-1.865 3.297a.3.3 0 0 1-.527-.009L6.83 18.506l-3.013.162a.3.3 0 0 1-.276-.45z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(AwardOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
